import React from 'react';
import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-6">
            <Link to="/faq" className="text-gray-600 hover:text-gray-900 transition-colors">
              FAQ
            </Link>
            <Link to="/terms" className="text-gray-600 hover:text-gray-900 transition-colors">
              Terms of Service
            </Link>
            <a 
              href="mailto:support@dittowallet.com" 
              className="text-gray-600 hover:text-gray-900 transition-colors"
            >
              Support
            </a>
          </div>
          <div className="text-gray-500 text-sm">
            © 2024 Ditto Digital Inc. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
} 